import { useState } from 'react'
import { ChevronLeftIcon } from '../Icons'
import './DebugConsole.css'

interface DebugConsoleProps {
  logs: string[]
  onClose: () => void
  onClear: () => void
}

const colors = {
  bg: '#050508',
  cardBg: '#141418',
  nestedBg: '#1c1c22',
  accent: '#9333ea',
  accentLight: '#a855f7',
  accentBorder: 'rgba(147, 51, 234, 0.25)',
  cardBorder: 'rgba(255, 255, 255, 0.12)',
  text: '#ffffff',
  textMuted: 'rgba(255, 255, 255, 0.52)',
}

export default function DebugConsole({ logs, onClose, onClear }: DebugConsoleProps) {
  const [copied, setCopied] = useState(false)

  const copyLogs = () => {
    navigator.clipboard.writeText(logs.join('\n'))
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: colors.bg,
      padding: '16px 20px',
      paddingBottom: '32px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
    }}>
      {/* Header с кнопкой назад */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '20px',
      }}>
        <button
          onClick={onClose}
          style={{
            background: colors.cardBg,
            border: `1px solid ${colors.cardBorder}`,
            borderRadius: '10px',
            padding: '10px 16px',
            color: colors.text,
            fontSize: '14px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontWeight: 500,
          }}
        >
          <ChevronLeftIcon size={16} />
          Назад
        </button>

        <div style={{
          color: colors.text,
          fontSize: '16px',
          fontWeight: 600,
        }}>
          Debug Console
        </div>

        <div style={{ width: '80px' }} /> {/* Spacer */}
      </div>

      {/* Кнопки действий */}
      <div style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '16px',
      }}>
        <button
          onClick={copyLogs}
          style={{
            flex: 1,
            background: colors.cardBg,
            border: `1px solid ${colors.cardBorder}`,
            borderRadius: '10px',
            padding: '12px',
            color: copied ? colors.accent : colors.text,
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          {copied ? '✓ Скопировано' : 'Копировать'}
        </button>
        
        <button
          onClick={onClear}
          style={{
            flex: 1,
            background: colors.cardBg,
            border: `1px solid ${colors.cardBorder}`,
            borderRadius: '10px',
            padding: '12px',
            color: colors.text,
            fontSize: '14px',
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Очистить
        </button>
      </div>

      {/* Логи */}
      <div style={{
        background: colors.cardBg,
        borderRadius: '14px',
        border: `1px solid ${colors.cardBorder}`,
        padding: '16px',
        minHeight: '400px',
        maxHeight: '70vh',
        overflowY: 'auto',
      }}>
        {logs.length === 0 ? (
          <div style={{
            color: colors.textMuted,
            fontSize: '14px',
            textAlign: 'center',
            paddingTop: '40px',
          }}>
            Логов пока нет
          </div>
        ) : (
          logs.map((log, index) => (
            <div
              key={index}
              style={{
                color: colors.text,
                fontSize: '12px',
                padding: '8px 0',
                borderBottom: index < logs.length - 1 ? `1px solid ${colors.cardBorder}` : 'none',
                fontFamily: 'monospace',
              }}
            >
              {log}
            </div>
          ))
        )}
      </div>
    </div>
  )
}
